import { handleCategoryName } from "@/features/private-room/list/utils/private-office-mappings";
import { Amenity } from "@/services/amenities/types";

type CheckboxOption = {
  id: string;
  label: string;
  checked?: boolean;
};

type CheckboxSection = {
  title: string;
  options: CheckboxOption[];
  columns: 1 | 2;
};

export function parseToCheckboxSections(
  amenities: Amenity[],
  selectedSlugs: string[] = [],
): CheckboxSection[] {
  const grouped: Record<string, CheckboxOption[]> = {};

  for (const amenity of amenities) {
    if (!grouped[amenity.category]) {
      grouped[amenity.category] = [];
    }

    grouped[amenity.category].push({
      id: amenity.slug,
      label: amenity.name,
      checked: selectedSlugs.includes(amenity.slug),
    });
  }

  return Object.entries(grouped).map(([category, options]) => ({
    title: handleCategoryName(category),
    options: options.sort((a, b) => a.label.localeCompare(b.label)),
    columns: 2,
  }));
}
